/**
 * @generated SignedSource<<31423f39fd8ab4798e54f74d4f29a3fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCompanyToBeDeletedInput = {
  companyId: number;
  toBeDeleted?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateCompanyToBeDeletedMutation$variables = {
  input: UpdateCompanyToBeDeletedInput;
};
export type updateCompanyToBeDeletedMutation$data = {
  readonly UpdateCompanyToBeDeleted: {
    readonly MissionControlCompanyToBeDeleted: {
      readonly id: string;
      readonly toBeDeleted: boolean | null;
    } | null;
  } | null;
};
export type updateCompanyToBeDeletedMutation = {
  variables: updateCompanyToBeDeletedMutation$variables;
  response: updateCompanyToBeDeletedMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCompanyToBeDeletedPayload",
    "kind": "LinkedField",
    "name": "UpdateCompanyToBeDeleted",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlCompanyToBeDeletedType",
        "kind": "LinkedField",
        "name": "MissionControlCompanyToBeDeleted",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toBeDeleted",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCompanyToBeDeletedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCompanyToBeDeletedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ef1a8a4d2d290123dbe77c8f3a89fc3",
    "id": null,
    "metadata": {},
    "name": "updateCompanyToBeDeletedMutation",
    "operationKind": "mutation",
    "text": "mutation updateCompanyToBeDeletedMutation(\n  $input: UpdateCompanyToBeDeletedInput!\n) {\n  UpdateCompanyToBeDeleted(input: $input) {\n    MissionControlCompanyToBeDeleted {\n      id\n      toBeDeleted\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "67bf4c5935dcd06dff4db90ef994060d";

export default node;
